export default __webpack_public_path__ + "static/media/home.d0823f76.svg";